<template>
    <b-modal size="lg" :visible="visible" centered no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="w-100">
            <h5>{{ title }}
                <button type="button" class="close"
                        @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <div>
          <slot>
            <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/> {{ copy }}
          </slot>
        </div>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="confirm(true)">{{ confirmButton }}</button>
            <button v-if="!alertOnly" type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="confirm(false)">{{cancelButton}}</button>
        </div>
    </b-modal>
</template>

<script>
  export default {
    name: 'confirm-modal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      copy: {
        type: String,
        required: false
      },
      confirmButton: {
        type: String,
        required: true
      },
      cancelButton: {
        type: String,
        required: false,
        default: 'Cancel'
      },
      alertOnly: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
      }
    },

    methods: {
      confirm (confirmed) {
        this.$emit('confirmed', confirmed)
      },

      closeModal () {
        this.$emit('update:visible', false)
      }

    }
  }
</script>

<style scoped>
    .confirm-modal-body {
        max-height: 490px;
        overflow-x: hidden;
        min-width: 300px;
    }

    .confirm-modal.in {
        display: flex !important; /*overide inline-style*/
        justify-content: center;
        align-items: center;
        min-height: 100px;
    }

</style>
